import React from "react";
import { StatusPill } from "./opus";

/**
 * StatusChip (OPUS-893 / OPUS-913) — one consistent status representation across
 * Users / Roles / Organisations / Renderers / Scenes. Now renders the design
 * system's StatusPill (tinted pill + colour dot + Title-Case label), so the raw
 * status value is preserved by callers while the look matches the handoff.
 */
export default function StatusChip({ status }) {
  return <StatusPill status={status} />;
}
